export const lightTheme = {
  name: 'light',
  background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
  glass: {
    background: 'rgba(255, 255, 255, 0.25)',
    border: '1px solid rgba(255, 255, 255, 0.18)',
    shadow: '0 8px 32px 0 rgba(31, 38, 135, 0.37)',
  },
  text: {
    primary: '#1a1a1a',
    secondary: '#4a4a4a',
    muted: '#6a6a6a',
  },
  accent: {
    primary: '#667eea',
    secondary: '#764ba2',
    hover: '#5a6fd8',
  },
  card: {
    background: 'rgba(255, 255, 255, 0.3)',
    border: '1px solid rgba(255, 255, 255, 0.2)',
  },
};

export const darkTheme = {
  name: 'dark',
  background: 'linear-gradient(135deg, #0f0d12 0%, #12061c 40%, #050810 100%)',
  glass: {
    background: 'rgba(255, 255, 255, 0.05)',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    shadow: '0 8px 32px 0 rgba(0, 0, 0, 0.37)',
  },
  text: {
    primary: '#ffffff',
    secondary: '#b0b0b0',
    muted: '#808080',
  },
  accent: {
    primary: '#b86fff',
    secondary: '#ff6661',
    hover: '#a55fff',
  },
  card: {
    background: 'rgba(255, 255, 255, 0.08)',
    border: '1px solid rgba(255, 255, 255, 0.15)',
  },
};

export const getTheme = (isDark) => (isDark ? darkTheme : lightTheme);






